<template>
    <autocomplete
        :search="search"
        placeholder="Введите ID или текст для поиска"
        aria-label="Введите ID или текст для поиска"
        :get-result-value="getResultValue"
        style="width: 400px;"
        @submit="onSubmit"
    />
</template>

<script>
    import Vue from 'vue';
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import '@trevoreyre/autocomplete-vue/dist/style.css';

    export default {
        name: 'ProductFinder',

        components: {
            Autocomplete,
        },

        props: {
            business_type: {
                type: String,
                default: null,
            },
            business_id: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                isAuthorized: false,
                searchString: null,
                searchUri: null,
                uri: null,
            };
        },

        watch: {},

        mounted() {
            if (!this.business_type) {
                console.log('No business_type.');
                return;
            }

            switch (this.business_type) {
            case 'grocer':
                this.uri = '/grocers/' + this.business_id + '/goods?search=';
                break;
            case 'pharmacy':
                this.uri = '/pharmacies/' + this.business_id + '/drugs?search=';
                break;
            case 'restaurant':
                this.uri = '/restaurants/' + this.business_id + '/dishes?search=';
                break;
            case 'entity':
                this.uri = `/entities/${this.business_id}/entity_products?search=`;
                break;
            case 'courier':
                this.uri = '/couriers?search=';
                break;
            case 'concierge':
                this.uri = '/concierges?search=';
                break;
            case 'promocodes':
                this.uri = '/promocodes?search=';
                break;
            }
        },

        methods: {
            search(input) {
                if (this.uri) {
                    return new Promise(resolve => {
                        if (input.length < 2) {
                            return resolve([]);
                        }

                        Vue.axios
                            .get(this.uri + input, {})
                            .then(resp => {
                                resolve(resp.data.results);
                            })
                            .catch(err => {
                                console.log('Cannot load list.');
                            });
                    });
                }
            },

            getResultValue(result) {
                if (this.business_type === 'promocodes') {
                    return 'ID: ' + result.id + ' | ' + result.code;
                }
                return 'ID: ' + result.id + ' | ' + (result.title ? result.title : result.name) + ' | Цена: ' + result.price;
            },

            onSubmit(result) {
                this.$emit('select', result.id);
            },
        },
    };
</script>

<style scoped>
</style>>
